/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { LogoThreadsIcon16Light } from './LogoThreadsIcon16Light';
import { LogoThreadsIcon16Regular } from './LogoThreadsIcon16Regular';
import { LogoThreadsIcon16Solid } from './LogoThreadsIcon16Solid';
import { LogoThreadsIcon20Light } from './LogoThreadsIcon20Light';
import { LogoThreadsIcon20Regular } from './LogoThreadsIcon20Regular';
import { LogoThreadsIcon20Solid } from './LogoThreadsIcon20Solid';
import { LogoThreadsIcon24Regular } from './LogoThreadsIcon24Regular';
import { LogoThreadsIcon24Solid } from './LogoThreadsIcon24Solid';
import { LogoThreadsIcon32Regular } from './LogoThreadsIcon32Regular';
import { LogoThreadsIcon64Regular } from './LogoThreadsIcon64Regular';
var sizes = {
    16: {
        light: LogoThreadsIcon16Light,
        regular: LogoThreadsIcon16Regular,
        solid: LogoThreadsIcon16Solid,
    },
    20: {
        light: LogoThreadsIcon20Light,
        regular: LogoThreadsIcon20Regular,
        solid: LogoThreadsIcon20Solid,
    },
    24: {
        regular: LogoThreadsIcon24Regular,
        solid: LogoThreadsIcon24Solid,
    },
    32: {
        regular: LogoThreadsIcon32Regular,
    },
    64: {
        regular: LogoThreadsIcon64Regular,
    },
};
export var LogoThreadsIcon = forwardRef('LogoThreadsIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
